import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './../../styles/cliente/pagos.css';
import * as globals from '../../components/GlobalScripts.js';

const Cliente_pagos = () => {
    const [payments, setPayments] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [searchState, setSearchState] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const getPayments = (page = 1, search = '') => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-payments/get_payments_client.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: page,
            itemsPerPage: itemsPerPage,
            search: search,
            searchState: searchState
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setPayments(response.data.payments);
                setTotalPages(response.data.totalPages);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvieron los pagos",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los pagos",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        getPayments(currentPage, searchDate);
    }, [currentPage, searchState]);

    const handleSearchDateChange = (e) => {
        const value = e.target.value;
        setSearchDate(value);
        const date = new Date(value);
        if (date.getFullYear() >= 2025) {
            setCurrentPage(1);
            if (currentPage == 1)
                getPayments(currentPage, value);
        }
    };

    const handleSearchStateChange = (e) => {
        setSearchState(e.target.value);
        setCurrentPage(1);
    };

    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    return (
        <div className="page-pagos container-section flex-column gap-20">
            <h3>Listado de pagos</h3>
            <div className="container-search">
                <div className='search'>
                    <label>Fecha de inicio:</label>
                    <input type="date" value={searchDate} onChange={handleSearchDateChange} className="input-primary" />
                </div>
                <div className='search'>
                    <label>Estado:</label>
                    <select value={searchState} onChange={handleSearchStateChange} className="input-primary">
                        <option value="">Todos</option>
                    </select>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Entorno</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {payments.map(payment => (
                        <tr key={payment.id}>
                            <td>{payment.id}</td>
                            <td>{payment.createAt}</td>
                            <td>{payment.email}</td>
                            <td>{payment.type_sell}</td>
                            <td>{payment.payment_status}</td>
                            <td className="table-actions">
                                <button className="edit-button" onClick={() => navigate(`/cliente/pagos/${payment.id}`)}>
                                    <svg viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M65.625 35C65.625 39.144 63.9788 43.1183 61.0485 46.0485C58.1183 48.9788 54.144 50.625 50 50.625C45.856 50.625 41.8817 48.9788 38.9515 46.0485C36.0212 43.1183 34.375 39.144 34.375 35C34.375 30.856 36.0212 26.8817 38.9515 23.9515C41.8817 21.0212 45.856 19.375 50 19.375C54.144 19.375 58.1183 21.0212 61.0485 23.9515C63.9788 26.8817 65.625 30.856 65.625 35Z" fill="black" />
                                        <path d="M0 35C0 35 18.75 0.625 50 0.625C81.25 0.625 100 35 100 35C100 35 81.25 69.375 50 69.375C18.75 69.375 0 35 0 35ZM50 56.875C55.8016 56.875 61.3656 54.5703 65.468 50.468C69.5703 46.3656 71.875 40.8016 71.875 35C71.875 29.1984 69.5703 23.6344 65.468 19.532C61.3656 15.4297 55.8016 13.125 50 13.125C44.1984 13.125 38.6344 15.4297 34.532 19.532C30.4297 23.6344 28.125 29.1984 28.125 35C28.125 40.8016 30.4297 46.3656 34.532 50.468C38.6344 54.5703 44.1984 56.875 50 56.875Z" fill="black" />
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Cliente_pagos;